import React from 'react';
import { isNil } from 'lodash';
import { Container } from '@fiverr-private/layout_components';
import { usePopoverContext } from '../PopoverContext';
import type { PopoverChevronProps } from '../types';

const PopoverChevron = ({ size = 'md', dataTestId }: PopoverChevronProps) => {
  const {
    arrowRef,
    floatingData: {
      middlewareData: { arrow },
      placement,
    },
  } = usePopoverContext();
  const arrowOffset = arrowRef?.current?.offsetWidth || 0;
  const side = placement.split('-')[0];
  const staticSide = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right',
  }[side] as string;

  const { x, y } = arrow || {};

  return (
    <Container
      data-testid={dataTestId}
      ref={arrowRef}
      zIndex="-1"
      style={{
        backgroundColor: 'inherit',
      }}
      position="absolute"
      width={size === 'sm' ? 12 : 16}
      height={size === 'sm' ? 12 : 16}
      transform="rotate(45deg)"
      pointerEvents="none"
      left={isNil(x) ? undefined : `${x}px`}
      top={isNil(y) ? undefined : `${y}px`}
      {...{ [staticSide]: `${-arrowOffset / 2}px` }}
    />
  );
};

PopoverChevron.displayName = 'PopoverChevron';

export default PopoverChevron;
